export var SALUTATION = "salutation";
export var FIRST_NAME = "firstName";
export var LAST_NAME = "lastName";
export var EMAIL = "email";
export var STREET = "street";
export var POSTAL_CODE = "postalCode"; // TODO: rename to zipcode
export var CITY = "city";
export var COUNTRY = "country";
export var CORPORATE_CLIENT = "corporate_client";
export var ORGANIZATION = "organization";
export var VAT_ID = "vat_id";
